export enum QueryKeys {
    RelayConfig = 'relay_config',
    UserState = 'user_state',
    UserInfo = 'user_info',
    HasSignedUp = 'has_signed_up',
    CurrentEpoch = 'current_epoch',
    EpochRemainingTime = 'epoch_remaining_time',
    Counter = 'counter',
    ManyPosts = 'many_posts',
    SinglePost = 'single_post',
    ManyComments = 'many_comments',
    ReportCategory = 'report_category',
    PendingReports = 'pending_reports',
    ReputationScore = 'reputation_score',
    ReputationHistory = 'reputation_history',
    PostHistory = 'post_history',
    CommentHistory = 'comment_history',
    VoteHistory = 'vote_history',
    ReportHistory = 'ReportHistory',
    ReportsWaitingForTransaction = 'ReportsWaitingForTransaction',
    Notifications = 'notifications',
    SingleReport = 'singleReport',
    Adjudicator = 'adjudicator',
}

export enum MutationKeys {
    RequestData = 'request_data',
    ProveData = 'prove_data',
    Login = 'login',
    LoginWithServer = 'login_with_server',
    LoginWithWallet = 'login_with_wallet',
    Logout = 'logout',
    Signup = 'signup',
    SignupWithServer = 'signup_with_server',
    SignupWithWallet = 'signup_with_wallet',
    UserStateTransition = 'user_state_transition',
    CreatePost = 'create_post',
    CreateComment = 'create_comment',
    RemoveComment = 'remove_comment',
    Vote = 'vote',
    ReportPost = 'report_post',
    ReportComment = 'report_comment',
    Adjudicate = 'adjudicate',
    CheckIn = 'check_in',
    ClaimReputation = 'claim_reputation',
    ClaimAdjudicatorReputation = 'claim_adjudicator_reputation',
    ClaimEpochKeyReputation = 'claim_epoch_key_reputation',
}
